export const stickyHeader = () => {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $(".js-l-top").addClass("l-top--window-scrolled");
        }
        if ($(this).scrollTop() < 80) {
            $(".js-l-top").removeClass("l-top--window-scrolled");
        }
    });
};
